import { Header } from "@/components/Header";
import { PremiumFooter } from "@/components/landing/PremiumFooter";
import { Calendar, User, ArrowRight, Tag } from "lucide-react";
import { Link } from "react-router-dom";

const featuredPost = {
  title: "L'avenir de la génération d'images IA : notre vision pour 2025",
  excerpt: "Découvrez notre roadmap et les innovations que nous préparons pour transformer la création visuelle. De nouvelles fonctionnalités révolutionnaires arrivent bientôt.",
  image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1200&h=600&fit=crop",
  author: "Équipe Floop",
  date: "3 décembre 2024",
  category: "Actualités",
  readTime: "5 min",
};

const posts = [
  {
    title: "Comment écrire des prompts parfaits : le guide ultime",
    excerpt: "Maîtrisez l'art du prompting pour obtenir des résultats exceptionnels à chaque fois.",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop",
    author: "Marie L.",
    date: "1 décembre 2024",
    category: "Tutoriels",
    readTime: "8 min",
  },
  {
    title: "Floop Pro vs Basic : comment choisir ?",
    excerpt: "Un comparatif détaillé pour vous aider à choisir le modèle adapté à vos besoins.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
    author: "Thomas D.",
    date: "28 novembre 2024",
    category: "Guides",
    readTime: "6 min",
  },
  {
    title: "10 artistes qui utilisent Floop dans leur workflow",
    excerpt: "Découvrez comment des créatifs professionnels intègrent l'IA dans leur processus créatif.",
    image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=600&h=400&fit=crop",
    author: "Sophie M.",
    date: "25 novembre 2024",
    category: "Inspiration",
    readTime: "10 min",
  },
  {
    title: "Les styles artistiques les plus populaires en 2024",
    excerpt: "Un tour d'horizon des tendances visuelles qui dominent la création assistée par IA.",
    image: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=600&h=400&fit=crop",
    author: "Lucas B.",
    date: "20 novembre 2024",
    category: "Tendances",
    readTime: "7 min",
  },
  {
    title: "Mise à jour majeure : nouvelles fonctionnalités de retouche",
    excerpt: "Découvrez les dernières améliorations apportées à Floop Pro pour des retouches encore plus précises.",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600&h=400&fit=crop",
    author: "Équipe Floop",
    date: "15 novembre 2024",
    category: "Actualités",
    readTime: "4 min",
  },
  {
    title: "IA générative et droits d'auteur : ce qu'il faut savoir",
    excerpt: "Un point complet sur les aspects juridiques de l'utilisation des images générées par IA.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&h=400&fit=crop",
    author: "Claire R.",
    date: "10 novembre 2024",
    category: "Juridique",
    readTime: "12 min",
  },
];

const categories = ["Tous", "Actualités", "Tutoriels", "Guides", "Inspiration", "Tendances"];

const Blog = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* Hero */}
      <section className="pt-24 pb-12 text-center">
        <div className="container mx-auto px-6">
          <span className="inline-block text-sm font-medium text-primary mb-4">
            Blog
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 font-display">
            Actualités & Ressources
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            Tutoriels, guides, actualités et inspirations pour tirer le meilleur de Floop.
          </p>
        </div>
      </section>

      {/* Categories */}
      <section className="pb-8">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <button
                key={category}
                className="px-4 py-2 rounded-full text-sm font-medium bg-secondary text-muted-foreground hover:text-foreground transition-colors"
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="pb-12">
        <div className="container mx-auto px-6">
          <div className="bg-card border border-border rounded-3xl overflow-hidden">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="aspect-video md:aspect-auto">
                <img
                  src={featuredPost.image}
                  alt={featuredPost.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-3 py-1 bg-primary/20 text-primary text-xs font-medium rounded-full">
                    {featuredPost.category}
                  </span>
                  <span className="text-sm text-muted-foreground">{featuredPost.readTime} de lecture</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
                  {featuredPost.title}
                </h2>
                <p className="text-muted-foreground mb-6">{featuredPost.excerpt}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <User className="w-4 h-4" />
                      {featuredPost.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {featuredPost.date}
                    </span>
                  </div>
                  <button className="flex items-center gap-2 text-primary font-medium hover:underline">
                    Lire l'article
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Posts Grid */}
      <section className="pb-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post, index) => (
              <article
                key={index}
                className="bg-card border border-border rounded-2xl overflow-hidden group hover:border-primary/50 transition-colors"
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2 py-0.5 bg-secondary text-xs font-medium text-muted-foreground rounded">
                      {post.category}
                    </span>
                    <span className="text-xs text-muted-foreground">{post.readTime}</span>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4 line-clamp-2">{post.excerpt}</p>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span>{post.author}</span>
                    <span>•</span>
                    <span>{post.date}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-16 bg-gradient-floop/10">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold text-foreground mb-4">
            Restez informé
          </h2>
          <p className="text-muted-foreground mb-6 max-w-md mx-auto">
            Recevez nos derniers articles et tutoriels directement dans votre boîte mail.
          </p>
          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="votre@email.com"
              className="flex-1 px-4 py-3 bg-input border border-border rounded-xl text-foreground"
            />
            <button className="px-6 py-3 bg-gradient-floop text-white rounded-xl font-medium hover:opacity-90 transition-opacity">
              S'abonner
            </button>
          </form>
        </div>
      </section>

      <PremiumFooter />
    </div>
  );
};

export default Blog;
